'use client';

import { TextField, Button, Stack } from '@mui/material';
import { useRouter } from '@/navigation';
import { useState } from 'react';
import { useTranslations } from 'next-intl';

export function PatentSearch() {
  const [searchQuery, setSearchQuery] = useState('');
  const router = useRouter();
  const t = useTranslations();
  return (
    <Stack flexDirection={'row'} gap={1}>
      <TextField value={searchQuery} onChange={event => setSearchQuery(event.target.value)} />
      <Button
        onClick={() => {
          router.refresh();
          router.push(`/patents?search=${searchQuery}&page=0&pageSize=10`);
        }}
      >
        {t('Search.search')}
      </Button>
    </Stack>
  );
}
